import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { authService } from "../services/authService";

export const useAuth = () => {
  const { user, setUser } = useContext(AuthContext);
  const navigate = useNavigate();

  if (typeof setUser === "undefined") {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  const login = async (credentials) => {
    const result = await authService.login(credentials);

    if (result.success) {
      setUser(result.user);
    }

    return result;
  };

  const googleLogin = async (accessToken) => {
    const result = await authService.googleLogin(accessToken);
    if (result.success) setUser(result.user);
    return result;
  };

  const facebookLogin = async (accessToken, userID) => {
    const result = await authService.facebookLogin(accessToken, userID);
    if (result.success) setUser(result.user);
    return result;
  };

  const googleLoginWithCode = async (code) => {
    const result = await authService.googleLoginWithCode(code); // token is the access_token string
    if (result.success) setUser(result.user);
    return result;
  };

  const register = async (userData) => {
    const result = await authService.register(userData);
    return result;
  };

  const sendSignupCode = async (userData) => {
    const result = await authService.sendSignupCode(userData);
    return result;
  };

  const verifySignupCode = async (userData) => {
    const result = await authService.verifySignupCode(userData);
    return result;
  };

  const forgotPassword = async (userData) => {
    const result = await authService.forgotPassword(userData);
    return result;
  };

  const resetPassword = async (userData) => {
    const result = await authService.resetPassword(userData);
    return result;
  };

  const resetPasswordByToken = async (userData) => {
    const result = await authService.resetPasswordByToken(userData);
    return result;
  };

  const logout = () => {
    authService.logout();
    setUser(null);
    navigate("/login");
  };

  return {
    user,
    setUser,
    login,
    googleLogin,
    facebookLogin,
    googleLoginWithCode,
    register,
    sendSignupCode,
    verifySignupCode,
    logout,
    forgotPassword,
    resetPassword,
    resetPasswordByToken,
    isAuthenticated: !!user,
  };
};
